import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const edit = {
	PpNr: null as string | null,
	PpNrText: null as string | null,
	SnppInfo: null as string | null,
	CacJdnPoc: null as number | null,
	Sleva: null as number | null,
	Nasobnost: null as number | null,
	PcPevna: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[editMutations.PRACOVNI_POZICE_PPNR_SELECT_MAPPER](state, { data }) {
			state.edit.PpNr = data.ppNr ? data.ppNr.trim() : null;
			state.edit.PpNrText = data.popis ? data.popis : null;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
